export default __webpack_public_path__ + "static/media/prezencne-pk-9-banner-graphics-2.7b3a8f7c.svg";